document.querySelectorAll('.lightbox-media-container').forEach(function(container, containerIdx) {
  var galleryId = 'fb-gallery-' + containerIdx;
  Array.from(container.querySelectorAll('[data-gallery-item]')).forEach(function(el) {
    if (!el.closest('.swiper-slide-duplicate')) {
      el.setAttribute('data-fancybox', galleryId);
    }
  });
});

Fancybox.bind('[data-fancybox^="fb-gallery-"]', {
  Html: {
    video: {
      autoplay: true,
      muted: true,
      loop: true
    }
  },
  on: {
    reveal: function(fancybox, slide) {
      var img = slide.el && slide.el.querySelector('img');
      var triggerEl = slide.triggerEl;
      if (img && triggerEl && triggerEl.dataset.srcset) {
        img.srcset = triggerEl.dataset.srcset;
        img.sizes = '100vw';
      }
      var video = slide.el && slide.el.querySelector('video');
      if (video) {
        video.muted = true;
        video.setAttribute('muted', '');
      }
    },
    destroy: function() {
      document.querySelectorAll('.lightbox-media-container video').forEach(function(video) {
        video.play();
      });
    }
  }
});

// Capture-phase handlers for videos — fires before theme.js can intercept
document.querySelectorAll('.lightbox-media-container').forEach(function(container, containerIdx) {
  var galleryId = 'fb-gallery-' + containerIdx;
  var allItems = Array.from(container.querySelectorAll('[data-fancybox="' + galleryId + '"]'));

  allItems.forEach(function(trigger, idx) {
    if (trigger.dataset.type !== 'html5video') return;

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      Fancybox.show(
        allItems.map(function(el) {
          var isVideo = el.dataset.type === 'html5video';
          return {
            src: el.getAttribute('href'),
            type: isVideo ? 'html5video' : 'image',
            srcset: !isVideo && el.dataset.srcset ? el.dataset.srcset : undefined,
            width: el.dataset.width ? parseInt(el.dataset.width) : undefined,
            height: el.dataset.height ? parseInt(el.dataset.height) : undefined,
            caption: el.dataset.caption || undefined
          };
        }),
        {
          startIndex: idx,
          Html: { video: { autoplay: true, muted: true, loop: true } },
          on: {
            reveal: function(fancybox, slide) {
              var video = slide.el && slide.el.querySelector('video');
              if (video) { video.muted = true; video.setAttribute('muted', ''); }
            },
            destroy: function() {
              container.querySelectorAll('video').forEach(function(v) { v.play(); });
            }
          }
        }
      );
    }, true);
  });
});
